/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HelpdeskRouteImport } from './routes/helpdesk'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HelpdeskIndexRouteImport } from './routes/helpdesk/index'
import { Route as HelpdeskTicketsRouteImport } from './routes/helpdesk/tickets'
import { Route as HelpdeskSettingsRouteImport } from './routes/helpdesk/settings'
import { Route as HelpdeskProfileRouteImport } from './routes/helpdesk/profile'
import { Route as HelpdeskOrgSettingsRouteImport } from './routes/helpdesk/org-settings'
import { Route as HelpdeskNotificationsRouteImport } from './routes/helpdesk/notifications'
import { Route as HelpdeskKnowledgeBaseRouteImport } from './routes/helpdesk/knowledge-base'
import { Route as HelpdeskDashboardRouteImport } from './routes/helpdesk/dashboard'
import { Route as HelpdeskCustomersRouteImport } from './routes/helpdesk/customers'
import { Route as AuthMagicLinkRouteImport } from './routes/auth.magic-link'
import { Route as HelpdeskTicketsIndexRouteImport } from './routes/helpdesk/tickets/index'
import { Route as HelpdeskOrgSettingsIndexRouteImport } from './routes/helpdesk/org-settings.index'
import { Route as HelpdeskKnowledgeBaseIndexRouteImport } from './routes/helpdesk/knowledge-base/index'
import { Route as HelpdeskCustomersIndexRouteImport } from './routes/helpdesk/customers/index'
import { Route as OrgOrgSlugPortalRouteImport } from './routes/org.$orgSlug.portal'
import { Route as OrgOrgSlugHelpdeskRouteImport } from './routes/org.$orgSlug.helpdesk'
import { Route as HelpdeskTicketsNewRouteImport } from './routes/helpdesk/tickets/new'
import { Route as HelpdeskTicketsIdRouteImport } from './routes/helpdesk/tickets/$id'
import { Route as HelpdeskOrgSettingsOrgIdRouteImport } from './routes/helpdesk/org-settings.$orgId'
import { Route as HelpdeskKnowledgeBaseNewRouteImport } from './routes/helpdesk/knowledge-base/new'
import { Route as HelpdeskKnowledgeBaseIdRouteImport } from './routes/helpdesk/knowledge-base/$id'
import { Route as HelpdeskCustomersNewRouteImport } from './routes/helpdesk/customers/new'
import { Route as HelpdeskCustomersIdRouteImport } from './routes/helpdesk/customers/$id'
import { Route as OrgOrgSlugPortalIndexRouteImport } from './routes/org/$orgSlug/portal/index'
import { Route as OrgOrgSlugPortalVerifyRouteImport } from './routes/org.$orgSlug.portal.verify'
import { Route as OrgOrgSlugPortalTicketsRouteImport } from './routes/org/$orgSlug/portal/tickets'
import { Route as OrgOrgSlugPortalSubmitTicketRouteImport } from './routes/org/$orgSlug/portal/submit-ticket'
import { Route as OrgOrgSlugPortalProfileRouteImport } from './routes/org/$orgSlug/portal/profile'
import { Route as OrgOrgSlugPortalLoginRouteImport } from './routes/org.$orgSlug.portal.login'
import { Route as OrgOrgSlugPortalKnowledgeBaseRouteImport } from './routes/org/$orgSlug/portal/knowledge-base'
import { Route as OrgOrgSlugPortalAutoLoginRouteImport } from './routes/org/$orgSlug/portal/auto-login'
import { Route as OrgOrgSlugPortalTicketsIndexRouteImport } from './routes/org/$orgSlug/portal/tickets/index'
import { Route as OrgOrgSlugPortalKnowledgeBaseIndexRouteImport } from './routes/org/$orgSlug/portal/knowledge-base/index'
import { Route as OrgOrgSlugPortalTicketsTicketIdRouteImport } from './routes/org/$orgSlug/portal/tickets/$ticketId'
import { Route as OrgOrgSlugPortalKnowledgeBaseArticleIdRouteImport } from './routes/org/$orgSlug/portal/knowledge-base/$articleId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpdeskRoute = HelpdeskRouteImport.update({
  id: '/helpdesk',
  path: '/helpdesk',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpdeskIndexRoute = HelpdeskIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HelpdeskRoute,
} as any)
const HelpdeskTicketsRoute = HelpdeskTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => HelpdeskRoute,
} as any)
const HelpdeskSettingsRoute = HelpdeskSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => HelpdeskRoute,
} as any)
const HelpdeskProfileRoute = HelpdeskProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => HelpdeskRoute,
} as any)
const HelpdeskOrgSettingsRoute = HelpdeskOrgSettingsRouteImport.update({
  id: '/org-settings',
  path: '/org-settings',
  getParentRoute: () => HelpdeskRoute,
} as any)
const HelpdeskNotificationsRoute = HelpdeskNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => HelpdeskRoute,
} as any)
const HelpdeskKnowledgeBaseRoute = HelpdeskKnowledgeBaseRouteImport.update({
  id: '/knowledge-base',
  path: '/knowledge-base',
  getParentRoute: () => HelpdeskRoute,
} as any)
const HelpdeskDashboardRoute = HelpdeskDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => HelpdeskRoute,
} as any)
const HelpdeskCustomersRoute = HelpdeskCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => HelpdeskRoute,
} as any)
const AuthMagicLinkRoute = AuthMagicLinkRouteImport.update({
  id: '/auth/magic-link',
  path: '/auth/magic-link',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpdeskTicketsIndexRoute = HelpdeskTicketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HelpdeskTicketsRoute,
} as any)
const HelpdeskOrgSettingsIndexRoute =
  HelpdeskOrgSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HelpdeskOrgSettingsRoute,
  } as any)
const HelpdeskKnowledgeBaseIndexRoute =
  HelpdeskKnowledgeBaseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HelpdeskKnowledgeBaseRoute,
  } as any)
const HelpdeskCustomersIndexRoute = HelpdeskCustomersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HelpdeskCustomersRoute,
} as any)
const OrgOrgSlugPortalRoute = OrgOrgSlugPortalRouteImport.update({
  id: '/org/$orgSlug/portal',
  path: '/org/$orgSlug/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgOrgSlugHelpdeskRoute = OrgOrgSlugHelpdeskRouteImport.update({
  id: '/org/$orgSlug/helpdesk',
  path: '/org/$orgSlug/helpdesk',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpdeskTicketsNewRoute = HelpdeskTicketsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => HelpdeskTicketsRoute,
} as any)
const HelpdeskTicketsIdRoute = HelpdeskTicketsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => HelpdeskTicketsRoute,
} as any)
const HelpdeskOrgSettingsOrgIdRoute =
  HelpdeskOrgSettingsOrgIdRouteImport.update({
    id: '/$orgId',
    path: '/$orgId',
    getParentRoute: () => HelpdeskOrgSettingsRoute,
  } as any)
const HelpdeskKnowledgeBaseNewRoute =
  HelpdeskKnowledgeBaseNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => HelpdeskKnowledgeBaseRoute,
  } as any)
const HelpdeskKnowledgeBaseIdRoute = HelpdeskKnowledgeBaseIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => HelpdeskKnowledgeBaseRoute,
} as any)
const HelpdeskCustomersNewRoute = HelpdeskCustomersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => HelpdeskCustomersRoute,
} as any)
const HelpdeskCustomersIdRoute = HelpdeskCustomersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => HelpdeskCustomersRoute,
} as any)
const OrgOrgSlugPortalIndexRoute = OrgOrgSlugPortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgOrgSlugPortalRoute,
} as any)
const OrgOrgSlugPortalVerifyRoute = OrgOrgSlugPortalVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => OrgOrgSlugPortalRoute,
} as any)
const OrgOrgSlugPortalTicketsRoute = OrgOrgSlugPortalTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => OrgOrgSlugPortalRoute,
} as any)
const OrgOrgSlugPortalSubmitTicketRoute =
  OrgOrgSlugPortalSubmitTicketRouteImport.update({
    id: '/submit-ticket',
    path: '/submit-ticket',
    getParentRoute: () => OrgOrgSlugPortalRoute,
  } as any)
const OrgOrgSlugPortalProfileRoute = OrgOrgSlugPortalProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => OrgOrgSlugPortalRoute,
} as any)
const OrgOrgSlugPortalLoginRoute = OrgOrgSlugPortalLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => OrgOrgSlugPortalRoute,
} as any)
const OrgOrgSlugPortalKnowledgeBaseRoute =
  OrgOrgSlugPortalKnowledgeBaseRouteImport.update({
    id: '/knowledge-base',
    path: '/knowledge-base',
    getParentRoute: () => OrgOrgSlugPortalRoute,
  } as any)
const OrgOrgSlugPortalAutoLoginRoute =
  OrgOrgSlugPortalAutoLoginRouteImport.update({
    id: '/auto-login',
    path: '/auto-login',
    getParentRoute: () => OrgOrgSlugPortalRoute,
  } as any)
const OrgOrgSlugPortalTicketsIndexRoute =
  OrgOrgSlugPortalTicketsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgOrgSlugPortalTicketsRoute,
  } as any)
const OrgOrgSlugPortalKnowledgeBaseIndexRoute =
  OrgOrgSlugPortalKnowledgeBaseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgOrgSlugPortalKnowledgeBaseRoute,
  } as any)
const OrgOrgSlugPortalTicketsTicketIdRoute =
  OrgOrgSlugPortalTicketsTicketIdRouteImport.update({
    id: '/$ticketId',
    path: '/$ticketId',
    getParentRoute: () => OrgOrgSlugPortalTicketsRoute,
  } as any)
const OrgOrgSlugPortalKnowledgeBaseArticleIdRoute =
  OrgOrgSlugPortalKnowledgeBaseArticleIdRouteImport.update({
    id: '/$articleId',
    path: '/$articleId',
    getParentRoute: () => OrgOrgSlugPortalKnowledgeBaseRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/helpdesk': typeof HelpdeskRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/auth/magic-link': typeof AuthMagicLinkRoute
  '/helpdesk/customers': typeof HelpdeskCustomersRouteWithChildren
  '/helpdesk/dashboard': typeof HelpdeskDashboardRoute
  '/helpdesk/knowledge-base': typeof HelpdeskKnowledgeBaseRouteWithChildren
  '/helpdesk/notifications': typeof HelpdeskNotificationsRoute
  '/helpdesk/org-settings': typeof HelpdeskOrgSettingsRouteWithChildren
  '/helpdesk/profile': typeof HelpdeskProfileRoute
  '/helpdesk/settings': typeof HelpdeskSettingsRoute
  '/helpdesk/tickets': typeof HelpdeskTicketsRouteWithChildren
  '/helpdesk/': typeof HelpdeskIndexRoute
  '/helpdesk/customers/$id': typeof HelpdeskCustomersIdRoute
  '/helpdesk/customers/new': typeof HelpdeskCustomersNewRoute
  '/helpdesk/knowledge-base/$id': typeof HelpdeskKnowledgeBaseIdRoute
  '/helpdesk/knowledge-base/new': typeof HelpdeskKnowledgeBaseNewRoute
  '/helpdesk/org-settings/$orgId': typeof HelpdeskOrgSettingsOrgIdRoute
  '/helpdesk/tickets/$id': typeof HelpdeskTicketsIdRoute
  '/helpdesk/tickets/new': typeof HelpdeskTicketsNewRoute
  '/org/$orgSlug/helpdesk': typeof OrgOrgSlugHelpdeskRoute
  '/org/$orgSlug/portal': typeof OrgOrgSlugPortalRouteWithChildren
  '/helpdesk/customers/': typeof HelpdeskCustomersIndexRoute
  '/helpdesk/knowledge-base/': typeof HelpdeskKnowledgeBaseIndexRoute
  '/helpdesk/org-settings/': typeof HelpdeskOrgSettingsIndexRoute
  '/helpdesk/tickets/': typeof HelpdeskTicketsIndexRoute
  '/org/$orgSlug/portal/auto-login': typeof OrgOrgSlugPortalAutoLoginRoute
  '/org/$orgSlug/portal/knowledge-base': typeof OrgOrgSlugPortalKnowledgeBaseRouteWithChildren
  '/org/$orgSlug/portal/login': typeof OrgOrgSlugPortalLoginRoute
  '/org/$orgSlug/portal/profile': typeof OrgOrgSlugPortalProfileRoute
  '/org/$orgSlug/portal/submit-ticket': typeof OrgOrgSlugPortalSubmitTicketRoute
  '/org/$orgSlug/portal/tickets': typeof OrgOrgSlugPortalTicketsRouteWithChildren
  '/org/$orgSlug/portal/verify': typeof OrgOrgSlugPortalVerifyRoute
  '/org/$orgSlug/portal/': typeof OrgOrgSlugPortalIndexRoute
  '/org/$orgSlug/portal/knowledge-base/$articleId': typeof OrgOrgSlugPortalKnowledgeBaseArticleIdRoute
  '/org/$orgSlug/portal/tickets/$ticketId': typeof OrgOrgSlugPortalTicketsTicketIdRoute
  '/org/$orgSlug/portal/knowledge-base/': typeof OrgOrgSlugPortalKnowledgeBaseIndexRoute
  '/org/$orgSlug/portal/tickets/': typeof OrgOrgSlugPortalTicketsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/auth/magic-link': typeof AuthMagicLinkRoute
  '/helpdesk/dashboard': typeof HelpdeskDashboardRoute
  '/helpdesk/notifications': typeof HelpdeskNotificationsRoute
  '/helpdesk/profile': typeof HelpdeskProfileRoute
  '/helpdesk/settings': typeof HelpdeskSettingsRoute
  '/helpdesk': typeof HelpdeskIndexRoute
  '/helpdesk/customers/$id': typeof HelpdeskCustomersIdRoute
  '/helpdesk/customers/new': typeof HelpdeskCustomersNewRoute
  '/helpdesk/knowledge-base/$id': typeof HelpdeskKnowledgeBaseIdRoute
  '/helpdesk/knowledge-base/new': typeof HelpdeskKnowledgeBaseNewRoute
  '/helpdesk/org-settings/$orgId': typeof HelpdeskOrgSettingsOrgIdRoute
  '/helpdesk/tickets/$id': typeof HelpdeskTicketsIdRoute
  '/helpdesk/tickets/new': typeof HelpdeskTicketsNewRoute
  '/org/$orgSlug/helpdesk': typeof OrgOrgSlugHelpdeskRoute
  '/helpdesk/customers': typeof HelpdeskCustomersIndexRoute
  '/helpdesk/knowledge-base': typeof HelpdeskKnowledgeBaseIndexRoute
  '/helpdesk/org-settings': typeof HelpdeskOrgSettingsIndexRoute
  '/helpdesk/tickets': typeof HelpdeskTicketsIndexRoute
  '/org/$orgSlug/portal/auto-login': typeof OrgOrgSlugPortalAutoLoginRoute
  '/org/$orgSlug/portal/login': typeof OrgOrgSlugPortalLoginRoute
  '/org/$orgSlug/portal/profile': typeof OrgOrgSlugPortalProfileRoute
  '/org/$orgSlug/portal/submit-ticket': typeof OrgOrgSlugPortalSubmitTicketRoute
  '/org/$orgSlug/portal/verify': typeof OrgOrgSlugPortalVerifyRoute
  '/org/$orgSlug/portal': typeof OrgOrgSlugPortalIndexRoute
  '/org/$orgSlug/portal/knowledge-base/$articleId': typeof OrgOrgSlugPortalKnowledgeBaseArticleIdRoute
  '/org/$orgSlug/portal/tickets/$ticketId': typeof OrgOrgSlugPortalTicketsTicketIdRoute
  '/org/$orgSlug/portal/knowledge-base': typeof OrgOrgSlugPortalKnowledgeBaseIndexRoute
  '/org/$orgSlug/portal/tickets': typeof OrgOrgSlugPortalTicketsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/helpdesk': typeof HelpdeskRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/auth/magic-link': typeof AuthMagicLinkRoute
  '/helpdesk/customers': typeof HelpdeskCustomersRouteWithChildren
  '/helpdesk/dashboard': typeof HelpdeskDashboardRoute
  '/helpdesk/knowledge-base': typeof HelpdeskKnowledgeBaseRouteWithChildren
  '/helpdesk/notifications': typeof HelpdeskNotificationsRoute
  '/helpdesk/org-settings': typeof HelpdeskOrgSettingsRouteWithChildren
  '/helpdesk/profile': typeof HelpdeskProfileRoute
  '/helpdesk/settings': typeof HelpdeskSettingsRoute
  '/helpdesk/tickets': typeof HelpdeskTicketsRouteWithChildren
  '/helpdesk/': typeof HelpdeskIndexRoute
  '/helpdesk/customers/$id': typeof HelpdeskCustomersIdRoute
  '/helpdesk/customers/new': typeof HelpdeskCustomersNewRoute
  '/helpdesk/knowledge-base/$id': typeof HelpdeskKnowledgeBaseIdRoute
  '/helpdesk/knowledge-base/new': typeof HelpdeskKnowledgeBaseNewRoute
  '/helpdesk/org-settings/$orgId': typeof HelpdeskOrgSettingsOrgIdRoute
  '/helpdesk/tickets/$id': typeof HelpdeskTicketsIdRoute
  '/helpdesk/tickets/new': typeof HelpdeskTicketsNewRoute
  '/org/$orgSlug/helpdesk': typeof OrgOrgSlugHelpdeskRoute
  '/org/$orgSlug/portal': typeof OrgOrgSlugPortalRouteWithChildren
  '/helpdesk/customers/': typeof HelpdeskCustomersIndexRoute
  '/helpdesk/knowledge-base/': typeof HelpdeskKnowledgeBaseIndexRoute
  '/helpdesk/org-settings/': typeof HelpdeskOrgSettingsIndexRoute
  '/helpdesk/tickets/': typeof HelpdeskTicketsIndexRoute
  '/org/$orgSlug/portal/auto-login': typeof OrgOrgSlugPortalAutoLoginRoute
  '/org/$orgSlug/portal/knowledge-base': typeof OrgOrgSlugPortalKnowledgeBaseRouteWithChildren
  '/org/$orgSlug/portal/login': typeof OrgOrgSlugPortalLoginRoute
  '/org/$orgSlug/portal/profile': typeof OrgOrgSlugPortalProfileRoute
  '/org/$orgSlug/portal/submit-ticket': typeof OrgOrgSlugPortalSubmitTicketRoute
  '/org/$orgSlug/portal/tickets': typeof OrgOrgSlugPortalTicketsRouteWithChildren
  '/org/$orgSlug/portal/verify': typeof OrgOrgSlugPortalVerifyRoute
  '/org/$orgSlug/portal/': typeof OrgOrgSlugPortalIndexRoute
  '/org/$orgSlug/portal/knowledge-base/$articleId': typeof OrgOrgSlugPortalKnowledgeBaseArticleIdRoute
  '/org/$orgSlug/portal/tickets/$ticketId': typeof OrgOrgSlugPortalTicketsTicketIdRoute
  '/org/$orgSlug/portal/knowledge-base/': typeof OrgOrgSlugPortalKnowledgeBaseIndexRoute
  '/org/$orgSlug/portal/tickets/': typeof OrgOrgSlugPortalTicketsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/forgot-password'
    | '/helpdesk'
    | '/login'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/auth/magic-link'
    | '/helpdesk/customers'
    | '/helpdesk/dashboard'
    | '/helpdesk/knowledge-base'
    | '/helpdesk/notifications'
    | '/helpdesk/org-settings'
    | '/helpdesk/profile'
    | '/helpdesk/settings'
    | '/helpdesk/tickets'
    | '/helpdesk/'
    | '/helpdesk/customers/$id'
    | '/helpdesk/customers/new'
    | '/helpdesk/knowledge-base/$id'
    | '/helpdesk/knowledge-base/new'
    | '/helpdesk/org-settings/$orgId'
    | '/helpdesk/tickets/$id'
    | '/helpdesk/tickets/new'
    | '/org/$orgSlug/helpdesk'
    | '/org/$orgSlug/portal'
    | '/helpdesk/customers/'
    | '/helpdesk/knowledge-base/'
    | '/helpdesk/org-settings/'
    | '/helpdesk/tickets/'
    | '/org/$orgSlug/portal/auto-login'
    | '/org/$orgSlug/portal/knowledge-base'
    | '/org/$orgSlug/portal/login'
    | '/org/$orgSlug/portal/profile'
    | '/org/$orgSlug/portal/submit-ticket'
    | '/org/$orgSlug/portal/tickets'
    | '/org/$orgSlug/portal/verify'
    | '/org/$orgSlug/portal/'
    | '/org/$orgSlug/portal/knowledge-base/$articleId'
    | '/org/$orgSlug/portal/tickets/$ticketId'
    | '/org/$orgSlug/portal/knowledge-base/'
    | '/org/$orgSlug/portal/tickets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/auth/magic-link'
    | '/helpdesk/dashboard'
    | '/helpdesk/notifications'
    | '/helpdesk/profile'
    | '/helpdesk/settings'
    | '/helpdesk'
    | '/helpdesk/customers/$id'
    | '/helpdesk/customers/new'
    | '/helpdesk/knowledge-base/$id'
    | '/helpdesk/knowledge-base/new'
    | '/helpdesk/org-settings/$orgId'
    | '/helpdesk/tickets/$id'
    | '/helpdesk/tickets/new'
    | '/org/$orgSlug/helpdesk'
    | '/helpdesk/customers'
    | '/helpdesk/knowledge-base'
    | '/helpdesk/org-settings'
    | '/helpdesk/tickets'
    | '/org/$orgSlug/portal/auto-login'
    | '/org/$orgSlug/portal/login'
    | '/org/$orgSlug/portal/profile'
    | '/org/$orgSlug/portal/submit-ticket'
    | '/org/$orgSlug/portal/verify'
    | '/org/$orgSlug/portal'
    | '/org/$orgSlug/portal/knowledge-base/$articleId'
    | '/org/$orgSlug/portal/tickets/$ticketId'
    | '/org/$orgSlug/portal/knowledge-base'
    | '/org/$orgSlug/portal/tickets'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/forgot-password'
    | '/helpdesk'
    | '/login'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/auth/magic-link'
    | '/helpdesk/customers'
    | '/helpdesk/dashboard'
    | '/helpdesk/knowledge-base'
    | '/helpdesk/notifications'
    | '/helpdesk/org-settings'
    | '/helpdesk/profile'
    | '/helpdesk/settings'
    | '/helpdesk/tickets'
    | '/helpdesk/'
    | '/helpdesk/customers/$id'
    | '/helpdesk/customers/new'
    | '/helpdesk/knowledge-base/$id'
    | '/helpdesk/knowledge-base/new'
    | '/helpdesk/org-settings/$orgId'
    | '/helpdesk/tickets/$id'
    | '/helpdesk/tickets/new'
    | '/org/$orgSlug/helpdesk'
    | '/org/$orgSlug/portal'
    | '/helpdesk/customers/'
    | '/helpdesk/knowledge-base/'
    | '/helpdesk/org-settings/'
    | '/helpdesk/tickets/'
    | '/org/$orgSlug/portal/auto-login'
    | '/org/$orgSlug/portal/knowledge-base'
    | '/org/$orgSlug/portal/login'
    | '/org/$orgSlug/portal/profile'
    | '/org/$orgSlug/portal/submit-ticket'
    | '/org/$orgSlug/portal/tickets'
    | '/org/$orgSlug/portal/verify'
    | '/org/$orgSlug/portal/'
    | '/org/$orgSlug/portal/knowledge-base/$articleId'
    | '/org/$orgSlug/portal/tickets/$ticketId'
    | '/org/$orgSlug/portal/knowledge-base/'
    | '/org/$orgSlug/portal/tickets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  HelpdeskRoute: typeof HelpdeskRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TermsRoute: typeof TermsRoute
  AuthMagicLinkRoute: typeof AuthMagicLinkRoute
  OrgOrgSlugHelpdeskRoute: typeof OrgOrgSlugHelpdeskRoute
  OrgOrgSlugPortalRoute: typeof OrgOrgSlugPortalRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/helpdesk': {
      id: '/helpdesk'
      path: '/helpdesk'
      fullPath: '/helpdesk'
      preLoaderRoute: typeof HelpdeskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/helpdesk/': {
      id: '/helpdesk/'
      path: '/'
      fullPath: '/helpdesk/'
      preLoaderRoute: typeof HelpdeskIndexRouteImport
      parentRoute: typeof HelpdeskRoute
    }
    '/helpdesk/tickets': {
      id: '/helpdesk/tickets'
      path: '/tickets'
      fullPath: '/helpdesk/tickets'
      preLoaderRoute: typeof HelpdeskTicketsRouteImport
      parentRoute: typeof HelpdeskRoute
    }
    '/helpdesk/settings': {
      id: '/helpdesk/settings'
      path: '/settings'
      fullPath: '/helpdesk/settings'
      preLoaderRoute: typeof HelpdeskSettingsRouteImport
      parentRoute: typeof HelpdeskRoute
    }
    '/helpdesk/profile': {
      id: '/helpdesk/profile'
      path: '/profile'
      fullPath: '/helpdesk/profile'
      preLoaderRoute: typeof HelpdeskProfileRouteImport
      parentRoute: typeof HelpdeskRoute
    }
    '/helpdesk/org-settings': {
      id: '/helpdesk/org-settings'
      path: '/org-settings'
      fullPath: '/helpdesk/org-settings'
      preLoaderRoute: typeof HelpdeskOrgSettingsRouteImport
      parentRoute: typeof HelpdeskRoute
    }
    '/helpdesk/notifications': {
      id: '/helpdesk/notifications'
      path: '/notifications'
      fullPath: '/helpdesk/notifications'
      preLoaderRoute: typeof HelpdeskNotificationsRouteImport
      parentRoute: typeof HelpdeskRoute
    }
    '/helpdesk/knowledge-base': {
      id: '/helpdesk/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/helpdesk/knowledge-base'
      preLoaderRoute: typeof HelpdeskKnowledgeBaseRouteImport
      parentRoute: typeof HelpdeskRoute
    }
    '/helpdesk/dashboard': {
      id: '/helpdesk/dashboard'
      path: '/dashboard'
      fullPath: '/helpdesk/dashboard'
      preLoaderRoute: typeof HelpdeskDashboardRouteImport
      parentRoute: typeof HelpdeskRoute
    }
    '/helpdesk/customers': {
      id: '/helpdesk/customers'
      path: '/customers'
      fullPath: '/helpdesk/customers'
      preLoaderRoute: typeof HelpdeskCustomersRouteImport
      parentRoute: typeof HelpdeskRoute
    }
    '/auth/magic-link': {
      id: '/auth/magic-link'
      path: '/auth/magic-link'
      fullPath: '/auth/magic-link'
      preLoaderRoute: typeof AuthMagicLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/helpdesk/tickets/': {
      id: '/helpdesk/tickets/'
      path: '/'
      fullPath: '/helpdesk/tickets/'
      preLoaderRoute: typeof HelpdeskTicketsIndexRouteImport
      parentRoute: typeof HelpdeskTicketsRoute
    }
    '/helpdesk/org-settings/': {
      id: '/helpdesk/org-settings/'
      path: '/'
      fullPath: '/helpdesk/org-settings/'
      preLoaderRoute: typeof HelpdeskOrgSettingsIndexRouteImport
      parentRoute: typeof HelpdeskOrgSettingsRoute
    }
    '/helpdesk/knowledge-base/': {
      id: '/helpdesk/knowledge-base/'
      path: '/'
      fullPath: '/helpdesk/knowledge-base/'
      preLoaderRoute: typeof HelpdeskKnowledgeBaseIndexRouteImport
      parentRoute: typeof HelpdeskKnowledgeBaseRoute
    }
    '/helpdesk/customers/': {
      id: '/helpdesk/customers/'
      path: '/'
      fullPath: '/helpdesk/customers/'
      preLoaderRoute: typeof HelpdeskCustomersIndexRouteImport
      parentRoute: typeof HelpdeskCustomersRoute
    }
    '/org/$orgSlug/portal': {
      id: '/org/$orgSlug/portal'
      path: '/org/$orgSlug/portal'
      fullPath: '/org/$orgSlug/portal'
      preLoaderRoute: typeof OrgOrgSlugPortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$orgSlug/helpdesk': {
      id: '/org/$orgSlug/helpdesk'
      path: '/org/$orgSlug/helpdesk'
      fullPath: '/org/$orgSlug/helpdesk'
      preLoaderRoute: typeof OrgOrgSlugHelpdeskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/helpdesk/tickets/new': {
      id: '/helpdesk/tickets/new'
      path: '/new'
      fullPath: '/helpdesk/tickets/new'
      preLoaderRoute: typeof HelpdeskTicketsNewRouteImport
      parentRoute: typeof HelpdeskTicketsRoute
    }
    '/helpdesk/tickets/$id': {
      id: '/helpdesk/tickets/$id'
      path: '/$id'
      fullPath: '/helpdesk/tickets/$id'
      preLoaderRoute: typeof HelpdeskTicketsIdRouteImport
      parentRoute: typeof HelpdeskTicketsRoute
    }
    '/helpdesk/org-settings/$orgId': {
      id: '/helpdesk/org-settings/$orgId'
      path: '/$orgId'
      fullPath: '/helpdesk/org-settings/$orgId'
      preLoaderRoute: typeof HelpdeskOrgSettingsOrgIdRouteImport
      parentRoute: typeof HelpdeskOrgSettingsRoute
    }
    '/helpdesk/knowledge-base/new': {
      id: '/helpdesk/knowledge-base/new'
      path: '/new'
      fullPath: '/helpdesk/knowledge-base/new'
      preLoaderRoute: typeof HelpdeskKnowledgeBaseNewRouteImport
      parentRoute: typeof HelpdeskKnowledgeBaseRoute
    }
    '/helpdesk/knowledge-base/$id': {
      id: '/helpdesk/knowledge-base/$id'
      path: '/$id'
      fullPath: '/helpdesk/knowledge-base/$id'
      preLoaderRoute: typeof HelpdeskKnowledgeBaseIdRouteImport
      parentRoute: typeof HelpdeskKnowledgeBaseRoute
    }
    '/helpdesk/customers/new': {
      id: '/helpdesk/customers/new'
      path: '/new'
      fullPath: '/helpdesk/customers/new'
      preLoaderRoute: typeof HelpdeskCustomersNewRouteImport
      parentRoute: typeof HelpdeskCustomersRoute
    }
    '/helpdesk/customers/$id': {
      id: '/helpdesk/customers/$id'
      path: '/$id'
      fullPath: '/helpdesk/customers/$id'
      preLoaderRoute: typeof HelpdeskCustomersIdRouteImport
      parentRoute: typeof HelpdeskCustomersRoute
    }
    '/org/$orgSlug/portal/': {
      id: '/org/$orgSlug/portal/'
      path: '/'
      fullPath: '/org/$orgSlug/portal/'
      preLoaderRoute: typeof OrgOrgSlugPortalIndexRouteImport
      parentRoute: typeof OrgOrgSlugPortalRoute
    }
    '/org/$orgSlug/portal/verify': {
      id: '/org/$orgSlug/portal/verify'
      path: '/verify'
      fullPath: '/org/$orgSlug/portal/verify'
      preLoaderRoute: typeof OrgOrgSlugPortalVerifyRouteImport
      parentRoute: typeof OrgOrgSlugPortalRoute
    }
    '/org/$orgSlug/portal/tickets': {
      id: '/org/$orgSlug/portal/tickets'
      path: '/tickets'
      fullPath: '/org/$orgSlug/portal/tickets'
      preLoaderRoute: typeof OrgOrgSlugPortalTicketsRouteImport
      parentRoute: typeof OrgOrgSlugPortalRoute
    }
    '/org/$orgSlug/portal/submit-ticket': {
      id: '/org/$orgSlug/portal/submit-ticket'
      path: '/submit-ticket'
      fullPath: '/org/$orgSlug/portal/submit-ticket'
      preLoaderRoute: typeof OrgOrgSlugPortalSubmitTicketRouteImport
      parentRoute: typeof OrgOrgSlugPortalRoute
    }
    '/org/$orgSlug/portal/profile': {
      id: '/org/$orgSlug/portal/profile'
      path: '/profile'
      fullPath: '/org/$orgSlug/portal/profile'
      preLoaderRoute: typeof OrgOrgSlugPortalProfileRouteImport
      parentRoute: typeof OrgOrgSlugPortalRoute
    }
    '/org/$orgSlug/portal/login': {
      id: '/org/$orgSlug/portal/login'
      path: '/login'
      fullPath: '/org/$orgSlug/portal/login'
      preLoaderRoute: typeof OrgOrgSlugPortalLoginRouteImport
      parentRoute: typeof OrgOrgSlugPortalRoute
    }
    '/org/$orgSlug/portal/knowledge-base': {
      id: '/org/$orgSlug/portal/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/org/$orgSlug/portal/knowledge-base'
      preLoaderRoute: typeof OrgOrgSlugPortalKnowledgeBaseRouteImport
      parentRoute: typeof OrgOrgSlugPortalRoute
    }
    '/org/$orgSlug/portal/auto-login': {
      id: '/org/$orgSlug/portal/auto-login'
      path: '/auto-login'
      fullPath: '/org/$orgSlug/portal/auto-login'
      preLoaderRoute: typeof OrgOrgSlugPortalAutoLoginRouteImport
      parentRoute: typeof OrgOrgSlugPortalRoute
    }
    '/org/$orgSlug/portal/tickets/': {
      id: '/org/$orgSlug/portal/tickets/'
      path: '/'
      fullPath: '/org/$orgSlug/portal/tickets/'
      preLoaderRoute: typeof OrgOrgSlugPortalTicketsIndexRouteImport
      parentRoute: typeof OrgOrgSlugPortalTicketsRoute
    }
    '/org/$orgSlug/portal/knowledge-base/': {
      id: '/org/$orgSlug/portal/knowledge-base/'
      path: '/'
      fullPath: '/org/$orgSlug/portal/knowledge-base/'
      preLoaderRoute: typeof OrgOrgSlugPortalKnowledgeBaseIndexRouteImport
      parentRoute: typeof OrgOrgSlugPortalKnowledgeBaseRoute
    }
    '/org/$orgSlug/portal/tickets/$ticketId': {
      id: '/org/$orgSlug/portal/tickets/$ticketId'
      path: '/$ticketId'
      fullPath: '/org/$orgSlug/portal/tickets/$ticketId'
      preLoaderRoute: typeof OrgOrgSlugPortalTicketsTicketIdRouteImport
      parentRoute: typeof OrgOrgSlugPortalTicketsRoute
    }
    '/org/$orgSlug/portal/knowledge-base/$articleId': {
      id: '/org/$orgSlug/portal/knowledge-base/$articleId'
      path: '/$articleId'
      fullPath: '/org/$orgSlug/portal/knowledge-base/$articleId'
      preLoaderRoute: typeof OrgOrgSlugPortalKnowledgeBaseArticleIdRouteImport
      parentRoute: typeof OrgOrgSlugPortalKnowledgeBaseRoute
    }
  }
}

interface HelpdeskCustomersRouteChildren {
  HelpdeskCustomersIdRoute: typeof HelpdeskCustomersIdRoute
  HelpdeskCustomersNewRoute: typeof HelpdeskCustomersNewRoute
  HelpdeskCustomersIndexRoute: typeof HelpdeskCustomersIndexRoute
}

const HelpdeskCustomersRouteChildren: HelpdeskCustomersRouteChildren = {
  HelpdeskCustomersIdRoute: HelpdeskCustomersIdRoute,
  HelpdeskCustomersNewRoute: HelpdeskCustomersNewRoute,
  HelpdeskCustomersIndexRoute: HelpdeskCustomersIndexRoute,
}

const HelpdeskCustomersRouteWithChildren =
  HelpdeskCustomersRoute._addFileChildren(HelpdeskCustomersRouteChildren)

interface HelpdeskKnowledgeBaseRouteChildren {
  HelpdeskKnowledgeBaseIdRoute: typeof HelpdeskKnowledgeBaseIdRoute
  HelpdeskKnowledgeBaseNewRoute: typeof HelpdeskKnowledgeBaseNewRoute
  HelpdeskKnowledgeBaseIndexRoute: typeof HelpdeskKnowledgeBaseIndexRoute
}

const HelpdeskKnowledgeBaseRouteChildren: HelpdeskKnowledgeBaseRouteChildren = {
  HelpdeskKnowledgeBaseIdRoute: HelpdeskKnowledgeBaseIdRoute,
  HelpdeskKnowledgeBaseNewRoute: HelpdeskKnowledgeBaseNewRoute,
  HelpdeskKnowledgeBaseIndexRoute: HelpdeskKnowledgeBaseIndexRoute,
}

const HelpdeskKnowledgeBaseRouteWithChildren =
  HelpdeskKnowledgeBaseRoute._addFileChildren(
    HelpdeskKnowledgeBaseRouteChildren,
  )

interface HelpdeskOrgSettingsRouteChildren {
  HelpdeskOrgSettingsOrgIdRoute: typeof HelpdeskOrgSettingsOrgIdRoute
  HelpdeskOrgSettingsIndexRoute: typeof HelpdeskOrgSettingsIndexRoute
}

const HelpdeskOrgSettingsRouteChildren: HelpdeskOrgSettingsRouteChildren = {
  HelpdeskOrgSettingsOrgIdRoute: HelpdeskOrgSettingsOrgIdRoute,
  HelpdeskOrgSettingsIndexRoute: HelpdeskOrgSettingsIndexRoute,
}

const HelpdeskOrgSettingsRouteWithChildren =
  HelpdeskOrgSettingsRoute._addFileChildren(HelpdeskOrgSettingsRouteChildren)

interface HelpdeskTicketsRouteChildren {
  HelpdeskTicketsIdRoute: typeof HelpdeskTicketsIdRoute
  HelpdeskTicketsNewRoute: typeof HelpdeskTicketsNewRoute
  HelpdeskTicketsIndexRoute: typeof HelpdeskTicketsIndexRoute
}

const HelpdeskTicketsRouteChildren: HelpdeskTicketsRouteChildren = {
  HelpdeskTicketsIdRoute: HelpdeskTicketsIdRoute,
  HelpdeskTicketsNewRoute: HelpdeskTicketsNewRoute,
  HelpdeskTicketsIndexRoute: HelpdeskTicketsIndexRoute,
}

const HelpdeskTicketsRouteWithChildren = HelpdeskTicketsRoute._addFileChildren(
  HelpdeskTicketsRouteChildren,
)

interface HelpdeskRouteChildren {
  HelpdeskCustomersRoute: typeof HelpdeskCustomersRouteWithChildren
  HelpdeskDashboardRoute: typeof HelpdeskDashboardRoute
  HelpdeskKnowledgeBaseRoute: typeof HelpdeskKnowledgeBaseRouteWithChildren
  HelpdeskNotificationsRoute: typeof HelpdeskNotificationsRoute
  HelpdeskOrgSettingsRoute: typeof HelpdeskOrgSettingsRouteWithChildren
  HelpdeskProfileRoute: typeof HelpdeskProfileRoute
  HelpdeskSettingsRoute: typeof HelpdeskSettingsRoute
  HelpdeskTicketsRoute: typeof HelpdeskTicketsRouteWithChildren
  HelpdeskIndexRoute: typeof HelpdeskIndexRoute
}

const HelpdeskRouteChildren: HelpdeskRouteChildren = {
  HelpdeskCustomersRoute: HelpdeskCustomersRouteWithChildren,
  HelpdeskDashboardRoute: HelpdeskDashboardRoute,
  HelpdeskKnowledgeBaseRoute: HelpdeskKnowledgeBaseRouteWithChildren,
  HelpdeskNotificationsRoute: HelpdeskNotificationsRoute,
  HelpdeskOrgSettingsRoute: HelpdeskOrgSettingsRouteWithChildren,
  HelpdeskProfileRoute: HelpdeskProfileRoute,
  HelpdeskSettingsRoute: HelpdeskSettingsRoute,
  HelpdeskTicketsRoute: HelpdeskTicketsRouteWithChildren,
  HelpdeskIndexRoute: HelpdeskIndexRoute,
}

const HelpdeskRouteWithChildren = HelpdeskRoute._addFileChildren(
  HelpdeskRouteChildren,
)

interface OrgOrgSlugPortalKnowledgeBaseRouteChildren {
  OrgOrgSlugPortalKnowledgeBaseArticleIdRoute: typeof OrgOrgSlugPortalKnowledgeBaseArticleIdRoute
  OrgOrgSlugPortalKnowledgeBaseIndexRoute: typeof OrgOrgSlugPortalKnowledgeBaseIndexRoute
}

const OrgOrgSlugPortalKnowledgeBaseRouteChildren: OrgOrgSlugPortalKnowledgeBaseRouteChildren =
  {
    OrgOrgSlugPortalKnowledgeBaseArticleIdRoute:
      OrgOrgSlugPortalKnowledgeBaseArticleIdRoute,
    OrgOrgSlugPortalKnowledgeBaseIndexRoute:
      OrgOrgSlugPortalKnowledgeBaseIndexRoute,
  }

const OrgOrgSlugPortalKnowledgeBaseRouteWithChildren =
  OrgOrgSlugPortalKnowledgeBaseRoute._addFileChildren(
    OrgOrgSlugPortalKnowledgeBaseRouteChildren,
  )

interface OrgOrgSlugPortalTicketsRouteChildren {
  OrgOrgSlugPortalTicketsTicketIdRoute: typeof OrgOrgSlugPortalTicketsTicketIdRoute
  OrgOrgSlugPortalTicketsIndexRoute: typeof OrgOrgSlugPortalTicketsIndexRoute
}

const OrgOrgSlugPortalTicketsRouteChildren: OrgOrgSlugPortalTicketsRouteChildren =
  {
    OrgOrgSlugPortalTicketsTicketIdRoute: OrgOrgSlugPortalTicketsTicketIdRoute,
    OrgOrgSlugPortalTicketsIndexRoute: OrgOrgSlugPortalTicketsIndexRoute,
  }

const OrgOrgSlugPortalTicketsRouteWithChildren =
  OrgOrgSlugPortalTicketsRoute._addFileChildren(
    OrgOrgSlugPortalTicketsRouteChildren,
  )

interface OrgOrgSlugPortalRouteChildren {
  OrgOrgSlugPortalAutoLoginRoute: typeof OrgOrgSlugPortalAutoLoginRoute
  OrgOrgSlugPortalKnowledgeBaseRoute: typeof OrgOrgSlugPortalKnowledgeBaseRouteWithChildren
  OrgOrgSlugPortalLoginRoute: typeof OrgOrgSlugPortalLoginRoute
  OrgOrgSlugPortalProfileRoute: typeof OrgOrgSlugPortalProfileRoute
  OrgOrgSlugPortalSubmitTicketRoute: typeof OrgOrgSlugPortalSubmitTicketRoute
  OrgOrgSlugPortalTicketsRoute: typeof OrgOrgSlugPortalTicketsRouteWithChildren
  OrgOrgSlugPortalVerifyRoute: typeof OrgOrgSlugPortalVerifyRoute
  OrgOrgSlugPortalIndexRoute: typeof OrgOrgSlugPortalIndexRoute
}

const OrgOrgSlugPortalRouteChildren: OrgOrgSlugPortalRouteChildren = {
  OrgOrgSlugPortalAutoLoginRoute: OrgOrgSlugPortalAutoLoginRoute,
  OrgOrgSlugPortalKnowledgeBaseRoute:
    OrgOrgSlugPortalKnowledgeBaseRouteWithChildren,
  OrgOrgSlugPortalLoginRoute: OrgOrgSlugPortalLoginRoute,
  OrgOrgSlugPortalProfileRoute: OrgOrgSlugPortalProfileRoute,
  OrgOrgSlugPortalSubmitTicketRoute: OrgOrgSlugPortalSubmitTicketRoute,
  OrgOrgSlugPortalTicketsRoute: OrgOrgSlugPortalTicketsRouteWithChildren,
  OrgOrgSlugPortalVerifyRoute: OrgOrgSlugPortalVerifyRoute,
  OrgOrgSlugPortalIndexRoute: OrgOrgSlugPortalIndexRoute,
}

const OrgOrgSlugPortalRouteWithChildren =
  OrgOrgSlugPortalRoute._addFileChildren(OrgOrgSlugPortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HelpdeskRoute: HelpdeskRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TermsRoute: TermsRoute,
  AuthMagicLinkRoute: AuthMagicLinkRoute,
  OrgOrgSlugHelpdeskRoute: OrgOrgSlugHelpdeskRoute,
  OrgOrgSlugPortalRoute: OrgOrgSlugPortalRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
